import { Outlet } from 'react-router-dom'
import { Suspense } from 'react'
import Footer from './Footer'
import { useAuth } from '@/app/providers/AuthProvider'
// import { Loader } from '@/components'
import Navbar from './Navbar'

function Layout() {
  const { user } = useAuth()
  // const location = useLocation();
  // const isResetPassword = location.pathname.startsWith('/confirm-password');

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-1">
        <Suspense >
          <Outlet />
        </Suspense>
      </main>

      {!user  && <Footer />}
    </div>
  )
}

export default Layout
